import React from "react";
import '../../App.css'
import TheFoundationCard from "../TheFoundationCard";
import Roots from "../Roots";

export default function TheFoundation(){
    return (
        <>
            <TheFoundationCard />
            <Roots />
        </>

    )
}